import React from 'react';
import {
  CheckCircleIcon,
} from '@heroicons/react/24/outline';

/**
 * Horizontal stepper of the create-article wizard.
 * Extracted verbatim from pages/Articles/CreateArticle.js.
 */
export default function WizardStepper({
  currentStep,
  navigateToStep,
  steps,
}) {
  return (
    <nav aria-label="Progress" className="w-full border-b bg-white select-none">
      <ol className="flex items-center justify-between border-gray-200 px-6 py-4 max-w-5xl mx-auto select-none">
        {steps.map((step, stepIdx) => (
          <li key={step.name} className={`flex items-center ${stepIdx !== steps.length - 1 ? 'w-full' : ''}`}>
            <div className="flex items-center">
              {step.status === 'complete' ? (
                <div
                  className="group cursor-pointer bg-transparent select-none"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => navigateToStep(step.step)}
                >
                  <span className="flex items-center">
                    <span className="relative flex h-5 w-5 shrink-0 items-center justify-center">
                      <CheckCircleIcon className="h-full w-full text-primary-600" />
                    </span>
                    <span className="ml-3 text-sm font-medium text-gray-500 hover:text-primary-600 transition-colors bg-transparent">
                      {step.name}
                    </span>
                  </span>
                </div>
              ) : step.status === 'current' ? (
                <div className="flex items-center bg-transparent select-none" aria-current="step">
                  <span className="relative flex h-5 w-5 shrink-0 items-center justify-center">
                    <span className="absolute h-4 w-4 rounded-full bg-primary-200" />
                    <span className="relative block h-2 w-2 rounded-full bg-primary-600" />
                  </span>
                  <span className="ml-3 text-sm font-medium text-primary-600 bg-transparent">{step.name}</span>
                </div>
              ) : (
                <div
                  className="group cursor-pointer bg-transparent select-none"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => step.step < currentStep && navigateToStep(step.step)}
                >
                  <div className="flex items-center bg-transparent">
                    <div className="relative flex h-5 w-5 shrink-0 items-center justify-center">
                      <div className="h-2 w-2 rounded-full bg-gray-300" />
                    </div>
                    <p className="ml-3 text-sm font-medium text-gray-500 hover:text-primary-600 transition-colors bg-transparent">
                      {step.name}
                    </p>
                  </div>
                </div>
              )}
            </div>
            {stepIdx !== steps.length - 1 && (
              <div className="flex-1 mx-4">
                <div className="h-0.5 w-full bg-gray-200">
                  <div
                    className="h-0.5 bg-primary-600 transition-all"
                    style={{ width: step.status === 'complete' ? '100%' : '0%' }}
                  />
                </div>
              </div>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
